import { RemoteFile } from '../type';

export function getFileName(file: RemoteFile): string|undefined {
  if (file.name) return file.name;
  return file.url.split('/').pop();
}

function getFileExt(fileName: string): string|undefined {
  const ext = fileName.split('.').pop();
  return (ext) ? ext.toLowerCase() : undefined;
}

export function isImage(fileName: string): boolean {
  const ext = getFileExt(fileName);
  if (ext) {
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
  }
  return false;
}

export function isVideo(fileName: string): boolean {
  const ext = getFileExt(fileName);
  if (ext) {
    return ['mp4', 'mov', 'wmv', 'flv', 'avi', 'mkv'].includes(ext);
  }
  return false;
}

export function isObjectUrl(url: string): boolean {
  return /^blob:/.test(url);
}
